import { dispatch } from "../../state/store";
import {
  removeLoadingLocationId,
  setLoadingLocationId,
  setLocationsError
} from "../../state/ducks";

import { strCode } from "../../consts";
import { locationsService, log, notificationService, t } from "../../services";
import { responseUtil } from "../../utils";

export const useDeleteStore = () => {
  const mutationCallback = async (id, market) => {
    dispatch(setLoadingLocationId(id));
    dispatch(setLocationsError(null));

    try {
      const res = await locationsService.deleteLocation(market, id);

      if (responseUtil.isResponseSuccessful(res)) {
        notificationService.showSuccess({
          title: t(strCode.EDIT_LOCATION_SUCCESS_TITLE),
          message: t(strCode.DELETE_LOCATION_SUCCESS_INFO)
        });
      }
    } catch (err) {
      dispatch(setLocationsError(err));
      log.error("UserManagementPage: Failed to delete store", err);
      notificationService.showError({
        title: t(strCode.DELETE_LOCATION_ERROR),
        message: err?.response?.data?.message ? err.response.data.message : err?.toString()
      });
    } finally {
      dispatch(removeLoadingLocationId(id));
      dispatch(setLocationsError(false));
    }
  };

  return { mutationCallback };
};
